import React, {useState} from "react";
import '../screens/Speech.css';

export default function Osc1({change, settings, changeType}){

	let {type, frequency, detune} = settings;

	return(
		<div className='control'>

			<h2>Oscylator</h2>

			<div className='param'>
				<h3>Częstotliwość</h3>
				<input value={frequency} onChange={change} max="5000" type='range' id='frequency' className='input'/>
			</div>

			<div className='param'>
				<h3>Rozstrajanie</h3>
				<input value={detune} onChange={change} max="5000" type='range' id='detune' className='input'/>
			</div>

			<div className='param'>
				<h3>Fala</h3>
				<button id='sine' onClick={changeType} className={type==='sine'?'btnF activeF':'btnF noactiveF'}>
					sinusowa</button>
				<button id='triangle' onClick={changeType} className={type==='triangle'?'btnF activeF':'btnF noactiveF'}>
					trójkątna</button>
				<button id='square' onClick={changeType} className={type==='square'?'btnF activeF':'btnF noactiveF'}>
					kwadratowa</button>
				<button id='sawtooth' onClick={changeType} className={type==='sawtooth'?'btnF activeF':'btnF noactiveF'}>
					piłokształtna</button>
			</div>
		</div>
	);
}